import { useState, useEffect } from 'react';
import api from './api';

export function Logs() {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        api.get('/logs').then((res) => setLogs(res.data));
    }, []);

    return (
        <div className="logs-page">
            <h2>Logs</h2>
            <div className="logs-list">
                {logs.map((log) => (
                    <div key={log.id} className="log-item">
                        <span className="log-time">{new Date(log.created_at).toLocaleString()}</span>
                        <span className="log-user">{log.username || 'system'}</span>
                        <span className="log-action">{log.action}</span>
                        {log.details && <span className="log-details">{log.details}</span>}
                    </div>
                ))}
            </div>
        </div>
    );
}
